import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildNavigateToWorkflowDraftSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const WORKFLOW_DRAFT_TOOL_NAMES = ['create_draft'];

const buildNavigateToWorkflowDraftSubscription = (
    _params: BuildNavigateToWorkflowDraftSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'navigate-to-workflow-draft',
        routePattern: '/agents/:agentId/workflows/:workflowId/versions/:versionId/builder',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, matchParams }) => {
            const toolMatches = eventMatchesToolNames({
                event,
                toolNames: WORKFLOW_DRAFT_TOOL_NAMES,
            });
            if (!toolMatches) {
                return false;
            }

            const result = coerceToRecord({ value: event.result });
            const args = coerceToRecord({ value: event.args });
            const draftVersionId = getStringValue({ value: result.draftVersionId });
            const workflowId = getStringValue({ value: args.workflowId });
            return draftVersionId !== '' && workflowId === matchParams.workflowId;
        },
        action: ({ event, navigate, matchParams }) => {
            const result = coerceToRecord({ value: event.result });
            const draftVersionId = getStringValue({ value: result.draftVersionId });
            const workflowId = matchParams.workflowId;
            const agentId = matchParams.agentId;

            navigate(
                `/agents/${agentId}/workflows/${workflowId}/versions/${draftVersionId}/builder`
            );
        },
    };
};

export default buildNavigateToWorkflowDraftSubscription;
